// extracted by mini-css-extract-plugin
export default {"content":"panel-item_content__kingZ","itemText":"panel-item_itemText__Z49Nd"};